/**
 * GMFlowPage - Phase 2F-1
 *
 * GM Mode portfolio building flow.
 * Uses GMStrategyHub v22 component with live API data.
 */
import { useParams } from 'react-router-dom';
import GMStrategyHub from './GMStrategyHub';

export function GMFlowPage(): JSX.Element {
  const { poolId } = useParams<{ poolId: string }>();
  
  return <GMStrategyHub poolId={poolId} />;
}